module.exports = __webpack_public_path__ + "static/media/cloud-meatball.5c522947.svg";